/**
 * PQRFillerMetalTable Component
 * 
 * Reusable component for rendering Filler Metals table (QW-404) in PQR PDFs
 */

import React from "react";
import { getPQRValue, getColumnClasses, bindWeldProcess } from "./pqrDataUtils";
import { pqrStyles } from "./pqrStyles";

const PQRFillerMetalTable = ({ pdf, type = "Groove", index = null }) => {
  const isOverlay = type === "Overlay";
  const { colwidth, col1Class, col2Class, col3Class } = getColumnClasses(pdf);
  

  // Multi-column mode for page 1
  const renderFillerMetalRows = () => {
    const fields = [
      { label: "SFA specification", field: "PQRD_FM_SFA" },
      { label: "AWS Classification", field: "PQRD_FM_Classification" },
      { label: "Filler Metal F No/ Weld Metal A No", field: "PQRD_FM_FNo", secondField: "PQRD_FM_Ano", separator: "/" },
      { label: "Filler metal nominal composition", field: "PQRD_FM_Nominal" },
      { label: "Filler metal trade name", field: "PQRD_FM_TradeName" },
      { label: "Filler metal product form", field: "PQRD_FM_ProductForm" },
      { label: "Deposited thickness", field: "PQRD_FM_DepositedThickness", unit: "mm" },
      { label: "Maximum pass thickness", field: "PQRD_FM_MaxPassThickness", unit: "mm" },
    ];

    if (isOverlay) {
      fields.push({ label: "Weld deposit chemistry", field: "PQRD_FM_WeldDepositChemistry" });
    }

    fields.push(
      { label: "Flux AWS specification & classification", field: "PQRD_FM_FluxAWS" },
      { label: "Flux trade name", field: "PQRD_FM_FluxTradeName" },
      { label: "Flux type", field: "PQRD_FM_FluxType" },
      { label: "Flux from recrushed slag", field: "PQRD_FM_FluxRecrushed" }
    );

    if (isOverlay) {
      fields.push(
        { label: "Flux nominal composition", field: "PQRD_FM_FluxNominalComposition" },
        { label: "Supplemental filler metal & Insert", field: "PQRD_FM_Supplement" },
        { label: "Filler metal others", field: "PQRD_FM_FillerMetalOthers", isLast: true }
      );
    } else {
      fields.push({ label: "Supplemental filler metal & Insert", field: "PQRD_FM_Supplement", isLast: true });
    }

    return fields.map((fieldConfig, index) => {
      const isSpecialRow = fieldConfig.field === "PQRD_FM_FillerMetalSize";
      const className = fieldConfig.isLast ? "PQRtrhide PQR_Botmrt" : "PQRtrhide PQR_right";
      const thClassName = fieldConfig.isLast ? "PQRfillerMetalth PQR_noTop" : "PQRfillerMetalth PQR_rt_lft";

      return (
        <tr key={fieldConfig.field} className={className} style={index==0 ? {borderTop:"1px solid black"}: {} }>
          <th className={thClassName} style={index==0? {borderTop:"1px solid black",width:"27%"} : {width:"27%"}}>
            {fieldConfig.label}
            {fieldConfig.unit && <div className="PQRrcorner"> {fieldConfig.unit} </div>}
          </th>
          <td className={col1Class} style={{ width: colwidth }}>
            {(() => {
              if (isSpecialRow) {
                return bindWeldProcess("PQRD_FM_FillerMetalSize", 1);
              }
              if (fieldConfig.secondField) {
                return `${getPQRValue(pdf[1]?.[fieldConfig.field])}${fieldConfig.separator}${getPQRValue(pdf[1]?.[fieldConfig.secondField])}`;
              }
              return getPQRValue(pdf[1]?.[fieldConfig.field]);
            })()}
          </td>
          <td className={col2Class} style={{ width: colwidth }}>
            {(() => {
              if (isSpecialRow) {
                return bindWeldProcess("PQRD_FM_FillerMetalSize", 2);
              }
              if (fieldConfig.secondField) {
                return `${getPQRValue(pdf[2]?.[fieldConfig.field])}${fieldConfig.separator}${getPQRValue(pdf[2]?.[fieldConfig.secondField])}`;
              }
              return getPQRValue(pdf[2]?.[fieldConfig.field]);
            })()}
          </td>
          <td className={col3Class} style={{ width: colwidth }}>
            {(() => {
              if (isSpecialRow) {
                return bindWeldProcess("PQRD_FM_FillerMetalSize", 3);
              }
              if (fieldConfig.secondField) {
                return `${getPQRValue(pdf[3]?.[fieldConfig.field])}${fieldConfig.separator}${getPQRValue(pdf[3]?.[fieldConfig.secondField])}`;
              }
              return getPQRValue(pdf[3]?.[fieldConfig.field]);
            })()}
          </td>
        
        </tr>
      );
    });
  };

  return (
    <>
      <div style={pqrStyles.group}>
        <div className="PQRbasemetal">FILLER METALS (QW- 404)</div>
      </div>
      <div style={pqrStyles.container}>
        <table id="table" className="PQRTable2" cellSpacing="0" style={{width:"570px"}}>
          <tbody>

            {renderFillerMetalRows()}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PQRFillerMetalTable;